import { Banner } from '@postscript/components';

import { AdminHost, isMerchantHost } from 'utils/adminHost';
import { ADMIN_HOST, ADMIN_ORIGIN, MERCHANT_HOST } from 'utils/envVars';

const openInCrew = () => {
  // A same-origin path from the current page, so no origin forcing needed.
  const { pathname, search, hash } = window.location;
  window.location.assign(`${ADMIN_ORIGIN}${pathname}${search}${hash}`);
};

const AdminHostBanner = ({ adminHost }: { adminHost?: AdminHost }) => {
  if (!adminHost?.show_banner || !isMerchantHost()) return null;

  return (
    <Banner
      variant="default"
      heading={`Admin tools are moving to ${ADMIN_HOST}`}
      bodyText={`You're signed in as Postscript staff. Admin tools on ${MERCHANT_HOST} will stop working soon; use ${ADMIN_HOST} instead.`}
      primaryAction={{ text: 'Open in crew', onClick: openInCrew }}
    />
  );
};

export default AdminHostBanner;
